import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
import {Link} from 'react-router-dom';

import {FancyPageSidebarItemButton} from './FancyPageSidebar';

type FancyPageSecondarySidebarProps = {
  items: FancyPageSidebarItemButton[];
  selectedItem?: FancyPageSidebarItemButton;
  baseUrl: string;
  isOpen: boolean;
  onClose: () => void;
};

export const FancyPageSecondarySidebar: React.FC<
  FancyPageSecondarySidebarProps
> = ({items, selectedItem, baseUrl, isOpen}) => {
  return (
    <div
      className={`fancy-page__secondary-sidebar ${
        isOpen ? 'fancy-page__secondary-sidebar--open' : ''
      }`}>
      <div className="fancy-page__secondary-sidebar__content">
        {items.map(item => (
          <Link
            key={item.slug}
            to={`${baseUrl}/${item.slug}`}
            className={`fancy-page__secondary-sidebar__item ${
              selectedItem?.slug === item.slug
                ? 'fancy-page__secondary-sidebar__item--selected'
                : ''
            }`}
            onClick={() => {
              item.onClick?.();
            }}>
            {item.iconName && <Icon name={item.iconName} className="large" />}
            <span className="fancy-page__secondary-sidebar__item__label">
              {item.name}
            </span>
            <Icon name="chevron-next" className="large" />
          </Link>
        ))}
      </div>
    </div>
  );
};
